import React from 'react';
import {
    IconFault,
    IconWarningType,
    IconInfoType,
    IconCondition,
} from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import { LimitConditions } from 'helpers/constants';


export const SET_EVENT_LOG_FILTERS = 'eventlog/SET_EVENT_LOG_FILTERS';
export const SET_EVENT_LOG_DATE_KIND = 'eventlog/SET_EVENT_LOG_DATE_KIND';
export const SET_IS_EXPAND = 'eventlog/SET_IS_EXPAND';
export const CLEAR_ASSISTANCE_PAGE = 'eventlist/assistance/CLEAR_ASSISTANCE_PAGE';
export const SET_SELECTED_EVENT = 'eventlog/SET_SELECTED_EVENT';
export const GET_EVENT_LOGS = 'detailedInformation/GET_EVENT_LOGS';
export const SET_SELECTED_ASSET = 'powertrainAssetDetails/SET_SELECTED_ASSET';
export const CLOSE_EVENT_LOG = 'eventDetailsSS/CLOSE_EVENT_LOG';
export const UPDATE_EVENT_LOGS = 'eventlog/UPDATE_EVENT_LOGS';
export const CLEAR_STORE = 'eventlog/CLEAR_STORE';
export const LOAD_CAPABILITIES = 'eventlog/LOAD_CAPABILITIES';
export const SET_SELECTED_ASSETS = 'eventlog/SET_SELECTED_ASSETS';
export const MAINTAIN_EVENT_DATA = 'eventlog/MAINTAIN_EVENT_DATA';
export const SET_EXPANDED_EVENT_GROUP = 'eventlog/SET_EXPANDED_EVENT_GROUP';
export const CLEAR_EXPANDED_EVENT_GROUP = 'eventlog/CLEAR_EXPANDED_EVENT_GROUP';

export const EventTypeAssetApplicability = {
    ALL: 0,
    DRIVE: 3,
    SMART_SENSOR: 1
};

export const dateKind = {
    UTC: 0,
    Local: 1
};

export const eventStatus = {
    ALL: 'All',
    OPEN: 'Open',
    CLOSED: 'Closed'
};

export const EventTypeIDs = {
    FAULT: 'Fault',
    ALERT: 'Alert',
    ALARM: 'Alarm',
    WARNING: 'Warning',
    INFO: 'Info'
};

export const eventClosingReason = {
    Dismiss: 'Dismiss',
    FalseAlarm: 'FalseAlarm',
    Corrected: 'Corrected',
    Auto: 'Auto'
};

export const causeOfEvents = {
    All: 'All',
    Unclassified: 'Unclassified',
    Irrelevant: 'Irrelevant',
    Drive: 'Drive',
    Motor: 'Motor',
    OtherPTC: 'OtherPTC',
    Process: 'Process',
    Ambient: 'Ambient',
    Unclear: 'Unclear'
};

export const EventTypes = [
    {
        typeID: EventTypeIDs.FAULT,
        icon: <IconFault />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeFault',
        applicableTo: EventTypeAssetApplicability.DRIVE
    },
    {
        typeID: EventTypeIDs.WARNING,
        icon: <IconWarningType />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeWarning',
        applicableTo: EventTypeAssetApplicability.DRIVE
    },
    {
        typeID: EventTypeIDs.ALARM,
        icon: <IconCondition condition={LimitConditions.Alarm.iconID} />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeAlarm',
        applicableTo: EventTypeAssetApplicability.ALL

    },
    {
        typeID: EventTypeIDs.ALERT,
        icon: <IconCondition condition={LimitConditions.Alert.iconID} />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeAlert',
        applicableTo: EventTypeAssetApplicability.ALL
    },
    {
        typeID: EventTypeIDs.INFO,
        icon: <IconInfoType color={colors.jungleGreen} />,
        label: 'ABB.Powertrain.Frontend.lblEventListEventTypeInfo',
        applicableTo: EventTypeAssetApplicability.DRIVE
    },
];

export const EventTypesIconWithName = [
    {
        typeID: EventTypeIDs.FAULT,
        icon: <IconFault />,
        applicableTo: EventTypeAssetApplicability.DRIVE
    },
    {
        typeID: EventTypeIDs.ALARM,
        icon: <IconCondition condition={LimitConditions.Alarm.iconID} />,
        applicableTo: EventTypeAssetApplicability.ALL
    },
    {
        typeID: EventTypeIDs.ALERT,
        icon: <IconCondition condition={LimitConditions.Alert.iconID} />,
        applicableTo: EventTypeAssetApplicability.ALL
    },
    {
        typeID: EventTypeIDs.WARNING,
        icon: <IconWarningType />,
        applicableTo: EventTypeAssetApplicability.ALL
    },
    {
        typeID: EventTypeIDs.INFO,
        icon: <IconInfoType color={colors.jungleGreen} />,
        applicableTo: EventTypeAssetApplicability.DRIVE
    },
];
